import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_CARD } from "../queries/useQueryCard";
import { QUERY_CARDS } from "../queries/useQueryCards";
import { createCard } from "../../../services/api/banking/cards";

export const useMutationCreateCard = () =>
  useWSMutation<
    cardApiSpec.Card,
    WSServiceError,
    cardApiSpec.CreateCardRequest
  >(createCard, {
    dependencies(response, { replacementForPaymentCardId }) {
      return [[QUERY_CARD, replacementForPaymentCardId], QUERY_CARDS];
    }
  });
